module.exports = __webpack_public_path__ + "static/media/intro.3d0d27c9.mp4";